/* eslint-disable no-unused-vars */
import { Box, Button, Center, useDisclosure } from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { clearDropdownCache } from "../../../db/indexedDB";
import LoadingSpinner from "../../../LoadingSpinner";
import apiClient from "../../../utils/ApiClient/apiClientAxios";
import { toastService } from "../../../utils/ApiClient/toastService";
import CustomModal from "../../Common/CustomModal/CustomModal";
import EditCodeDataTable from "./EditCodeDataTable";
import EditCodeForm from "./EditCodeForm";

const EditCode = () => {
  const [loading, setLoading] = useState(false);
  const [getCodeLoading, setGetCodeLoading] = useState(false);
  const [codeData, setCodeData] = useState([]);
  const [selectedCodeData, setSelectedCodeData] = useState(null);
  const [activeConfigID, setActiveConfigID] = useState(null);
  const [desctiption, setDescription] = useState();
  const [isSavingEditedCode, setIsSavingEditedCode] = useState(false);
  const formRef = useRef();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const handleEdit = (codeID) => {
    setActiveConfigID(codeID);
    onOpen();
    const fetchCodes = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/api/getCodes", {
          params: { id: codeID },
        });

        setSelectedCodeData(response?.data);
        setDescription(response.data?.DESCRIPTION);
      } catch (err) {
        console.error("Failed to load codes", err);
        // setSelectedCodeData(demoEditCodeData);
        // setDescription(demoEditCodeData?.DESCRIPTION);
      } finally {
        setLoading(false);
      }
    };
    fetchCodes();
  };

  const handleSave = async (options) => {
    setIsSavingEditedCode(true);

    // 🔹 Clean empty values from each option
    const cleanedOptions = options.map((option) =>
      Object.entries(option).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {}),
    );

    const payload = {
      id: activeConfigID,
      TYPE: "CODE",
      CONFIG: cleanedOptions,
      DESCRIPTION: desctiption,
    };

    try {
      const response = await apiClient.post("/writeConfig", payload);
      toastService.success(response.data);

      await clearDropdownCache(activeConfigID, null);
      onClose();
      setDescription("");
      getListCodes();
    } catch (err) {
      console.error("Save failed", err);
    } finally {
      setIsSavingEditedCode(false);
    }
  };

  // ==========================
  const getListCodes = async () => {
    setGetCodeLoading(true);
    try {
      const response = await axios.get("/api/listCodes");
      setCodeData(response?.data);
    } catch (err) {
      console.error("Failed to load codes", err);
      // setCodeData(demoCodeData);
    } finally {
      setGetCodeLoading(false);
    }
  };

  useEffect(() => {
    getListCodes();
  }, []);

  if (getCodeLoading) {
    return (
      <Box h="70vh">
        <Center>
          <LoadingSpinner />
        </Center>
      </Box>
    );
  }

  return (
    <Box>
      <Box w="70%" mx="auto">
        <EditCodeDataTable
          codeData={codeData}
          handleEdit={handleEdit}
          setCodeData={setCodeData}
          getListCodes={getListCodes}
        />
      </Box>

      <CustomModal
        size="5xl"
        isCentered={false}
        isOpen={isOpen}
        onClose={onClose}
        bodyContent={
          <Box>
            {loading ? (
              <LoadingSpinner />
            ) : (
              <EditCodeForm
                apiData={selectedCodeData}
                onSubmit={handleSave}
                formRef={formRef}
                setDescription={setDescription}
                desctiption={desctiption}
              />
            )}
          </Box>
        }
        footerContent={
          <Box display="flex" alignItems="center" gap={2}>
            <Button onClick={onClose}>Discard</Button>
            <Button
              isLoading={isSavingEditedCode}
              loadingText="Saving..."
              variant="primary"
              onClick={() => {
                if (formRef.current) {
                  formRef.current.submit();
                }
              }}
            >
              Save
            </Button>
          </Box>
        }
      />
    </Box>
  );
};

export default EditCode;
